import {
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
  POOL_COLUMNS,
  ROW_HEIGHT,
} from '../../data/publicPools'
import PoolRow from './PoolRow'

function columnClass(column) {
  return column.grow
    ? 'flex items-center py-1 leading-2xs font-normal whitespace-nowrap uppercase font-mono label-meta text-muted grow min-w-0'
    : 'flex items-center py-1 leading-2xs font-normal whitespace-nowrap uppercase font-mono label-meta text-muted grow-0 shrink-0'
}

export default function PoolsTable({
  testId,
  pools,
  sortable = false,
  sortKey = 'tvl',
  sortDirection = 'desc',
  onSort,
  maxHeight,
}) {
  const bodyHeight = pools.length * ROW_HEIGHT
  const frameHeight =
    maxHeight ?? HEADER_HEIGHT + bodyHeight + FOOTER_HEIGHT

  return (
    <div className="relative size-full overflow-auto" style={{ height: frameHeight }}>
      <table
        data-testid={testId}
        className="relative z-0 grid text-xs whitespace-nowrap text-ink bg-transparent"
      >
        <thead className="sticky top-0 z-5 grid align-middle border-b-[0.5px] border-line [background:linear-gradient(var(--color-fill),var(--color-fill)),var(--color-bg)]">
          <tr className="flex w-full items-center gap-3 px-3 h-9 min-h-0">
            {POOL_COLUMNS.map((column) => {
              const active = sortable && sortKey === column.id
              return (
                <th
                  key={column.id}
                  className={columnClass(column)}
                  role="columnheader"
                  style={{ width: column.width }}
                >
                  {sortable ? (
                    <button
                      type="button"
                      className={
                        active
                          ? 'flex cursor-pointer items-center gap-1 uppercase transition-colors select-none hover:text-ink text-ink'
                          : 'flex cursor-pointer items-center gap-1 uppercase transition-colors select-none hover:text-ink'
                      }
                      onClick={() => onSort?.(column.id)}
                    >
                      {column.label}
                      {active ? (
                        <span
                          aria-hidden="true"
                          data-direction={sortDirection}
                          className="flex shrink-0 items-center"
                          style={
                            sortDirection === 'asc'
                              ? { transform: 'rotate(180deg)' }
                              : undefined
                          }
                        >
                          <span
                            data-icon="true"
                            className="flex shrink-0 items-center justify-center size-[8px] text-ink/70"
                          >
                            <svg
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="size-full"
                            >
                              <path
                                d="M1.5 3 4 5.5 6.5 3"
                                stroke="currentColor"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </span>
                      ) : null}
                    </button>
                  ) : (
                    column.label
                  )}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody className="relative grid" style={{ height: bodyHeight }}>
          {pools.map((pool, index) => (
            <PoolRow key={pool.id} pool={pool} index={index} />
          ))}
        </tbody>
        <tfoot>
          <tr className="flex w-full">
            <td className="w-full" colSpan={9}>
              <div aria-hidden="true" className="h-2" />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
